import reducer from './reducers';

export { default as changePermissionsSelectors } from './selectors';
export { default as changePermissionsOperations } from './operations';
export { default as changePermissionsTypes } from './types';

export default reducer;
